import { blockCategories } from '../categories';

export default function (editor) {
    const bm = editor.BlockManager;

    const step = 0.2;
    const minDim = 1;
    const currentUnit = 1;
    const resizerBtm = {
        tl: 0,
        tc: 0,
        tr: 0,
        cl: 0,
        cr: 0,
        bl: 0,
        br: 0,
        minDim,
    };
    const resizerRight = {
        ...resizerBtm,
        cr: 1,
        bc: 0,
        currentUnit,
        minDim,
        step,
    };

    // Columns are flex-based, so resizer uses flex-basis.
    resizerRight.keyWidth = 'flex-basis';

    const rowAttr = {
        'data-gjs-droppable': true,
        'data-gjs-resizable': resizerBtm,
        'data-gjs-name': 'Row',
    };

    const colAttr = {
        'data-gjs-type': 'column',
        'data-gjs-draggable': true,
        'data-gjs-droppable': true,
        'data-gjs-resizable': resizerRight,
        'data-gjs-name': 'Column',
    };
    colAttr['data-gjs-unstylable'] = ['width'];
    colAttr['data-gjs-stylable-require'] = ['flex-basis'];

    const attrsToString = (attrs) => {
        const result = [];

        for (let key in attrs) {
            let value = attrs[key];
            const toParse = value instanceof Array || value instanceof Object;
            value = toParse ? JSON.stringify(value) : value;
            result.push(`${key}=${toParse ? `'${value}'` : `'${value}'`}`);
        }

        return result.length ? ` ${result.join(' ')}` : '';
    };

    const attrsRow = attrsToString(rowAttr);
    const attrsCell = attrsToString(colAttr);
    const commonBlockProps = {
        category: blockCategories.layout,
        select: true,
    };

    bm.add('column1', {
        ...commonBlockProps,
        label: '1 Spalte',
        component: 'column1',
        media: `<svg viewBox="0 0 24 24">
        <path  width="24" height="24" fill="currentColor" d="M2 20h20V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z"/>
      </svg>`,
        content: `<div ${attrsRow} data-gjs-type="column" class="w-full">
        <div ${attrsCell}></div>
      </div>`,
    });

    bm.add('column2', {
        ...commonBlockProps,
        label: '2 Spalten',
        component: 'column2',
        media: `<svg viewBox="0 0 23 24">
        <path fill="currentColor" d="M2 20h8V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM13 20h8V4h-8v16Zm-1 0V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Z"/>
      </svg>`,
        content: `<div ${attrsRow} data-gjs-type="column2" class="grid grid-cols-1 gap-2 md:grid-cols-2">
        <div ${attrsCell}></div>
        <div ${attrsCell}></div>
      </div>`,
    });

    bm.add('column3', {
        ...commonBlockProps,
        label: '3 Spalten',
        component: 'column3',
        media: `<svg viewBox="0 0 23 24">
        <path fill="currentColor" d="M2 20h4V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM17 20h4V4h-4v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1ZM9.5 20h4V4h-4v16Zm-1 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1Z"/>
      </svg>`,
        content: `<div ${attrsRow} data-gjs-type="column3" class="md:flex flex-wrap gap-2 w-full">
        <div ${attrsCell} class="flex md:flex-1"></div>
        <div ${attrsCell} class="flex md:flex-1"></div>
        <div ${attrsCell} class="flex md:flex-1"></div>
      </div>`,
    });

    bm.add('column3-7', {
        ...commonBlockProps,
        label: '2 Spalten 3/7',
        component: 'column37',
        media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M2 20h5V4H2v16Zm-1 0V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1ZM10 20h12V4H10v16Zm-1 0V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1Z"/>
      </svg>`,
        content: `<div ${attrsRow} data-gjs-type="column37" class="md:flex flex-wrap">
        <div ${attrsCell} class="md:w-4/12 sm:pr-4 pr-0"></div>
        <div ${attrsCell} class="md:w-8/12"></div>
      </div>`,
    });

    editor.DomComponents.addType('column2', {
        model: {
            defaults: {
                traits: [
                    {
                        type: 'select',
                        label: 'Wrap',
                        name: 'flex-wrap',
                        options: [
                            { value: 'nowrap', name: 'No Wrap' },
                            { value: 'wrap', name: 'Wrap' },
                        ],
                        changeProp: 1,
                    },
                ],
            },
        },
    });

    editor.DomComponents.addType('column3', {
        model: {
            defaults: {
                traits: [
                    {
                        type: 'select',
                        label: 'Wrap',
                        name: 'flex-wrap',
                        options: [
                            { value: 'nowrap', name: 'No Wrap' },
                            { value: 'wrap', name: 'Wrap' },
                        ],
                        changeProp: 1,
                    },
                ],
            },
        },
    });

    editor.DomComponents.addType('column37', {
        model: {
            defaults: {
                traits: [
                    {
                        type: 'select',
                        label: 'Wrap',
                        name: 'flex-wrap',
                        options: [
                            { value: 'nowrap', name: 'No Wrap' },
                            { value: 'wrap', name: 'Wrap' },
                        ],
                        changeProp: 1,
                    },
                ],
            },
        },
    });
}
